import PropTypes from "prop-types";
import "./commonLineTable.css";

const CommonZoneTable = ({ data, columns, rowHeaderLabel = "Weekly Trend" }) => {
  return (
    <div className="table-wrapper">
      <div className="table-scroll">
        <table className="zone-table">
          <thead>
            <tr>
              <th className="sticky-col">{rowHeaderLabel}</th>
              {columns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row) => (
              <tr key={row.label}>
                <td className="sticky-col row-title">{row.label}</td>

                {row.values.map((cell, colIndex) => (
                  <td
                    key={`${row.label}-${columns[colIndex]}`}
                    className={`zone-cell ${
                      row.zones?.[colIndex]?.toLowerCase() || ""
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

CommonZoneTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      ).isRequired,
      zones: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,
  rowHeaderLabel: PropTypes.string,
};

export default CommonZoneTable;
